import type { UserState, Countries, Langs } from '@/redux/user/types';
import { getUserState } from '@/redux/user/selectors';
import { MCD } from '@/services/app';
import Store from '@/redux';

import {
  setUserData,
  setUserPoints,
  setUserCountry,
  setUserLanguage
} from '@/redux/user/actions';

const setDocumentLanguage = (
  user: UserState = getUserState(Store.getState())
) => {
  let { country = '', language = '' } = user;
  country &&= `-${country.slice(-2).toLocaleUpperCase()}`;
  document.documentElement.setAttribute('lang', `${language}${country}`);
};

export const checkUserData = async () => {
  try {
    const userData = (await MCD.getUserData()) as UserState;
    console.info('User Data:', userData);
    Store.dispatch(setUserData(userData));
  } catch (error) {
    console.error('"checkUserData" error:', error);
    throw error;
  }
};

export const checkUserPoints = async () => {
  try {
    const userPoints = await MCD.getUserPoints();
    console.info('User Points:', userPoints);
    Store.dispatch(setUserPoints(userPoints));
  } catch (error) {
    console.error('"checkUserPoints" error:', error);
    throw error;
  }
};

export const checkUserCountry = async () => {
  try {
    const userCountry = (
      await MCD.getUserCountry()
    ).toLocaleLowerCase() as Countries;

    console.info('User Country:', userCountry);
    Store.dispatch(setUserCountry(userCountry));
    setDocumentLanguage();
  } catch (error) {
    console.error('"checkUserCountry" error:', error);
    throw error;
  }
};

export const checkUserLanguage = async () => {
  const rtlDirLangs = new Set(['ar', 'az', 'dv', 'fa', 'he', 'ku', 'ur']);

  try {
    const userLanguage = (
      await MCD.getUserLanguage()
    ).toLocaleLowerCase() as Langs;

    const countrySeparator = userLanguage.indexOf('-');
    const end = countrySeparator > -1 && countrySeparator;

    const language = userLanguage.slice(0, end || undefined);
    const dir = rtlDirLangs.has(language) && 'rtl' || 'ltr';

    document.documentElement.setAttribute('dir', dir);
    console.info('User Language:', language);
    Store.dispatch(setUserLanguage(language));
    setDocumentLanguage();
  } catch (error) {
    console.error('"checkUserLanguage" error:', error);
    throw error;
  }
};
